<!-- Created By Rahul VK  -->

<div class="topDiv" [style.background-color]="backgroundColorScreen">
  <div style="margin-top:3%">
    <div class="vaultDataloadHeadDiv">
      <h4>Comparative Report Dashboard</h4>
    </div>


  </div>

  <div class="agGridOuterDiv" style="height: fit-content; width: fit-content;">
    <div>
      <mat-toolbar class="agGridtoperDiv card"
        style="background: rgb(230 227 230 / 41%);border-top: 1px solid #a9a9a9a8;border-right: 1px solid #a9a9a9a8; border-left: 1px solid #a9a9a9a8; height: fit-content; display: flex;  align-items: center;width:100%; padding-right: 0; flex-wrap:wrap; justify-content: space-between; ">
        <label i18n="@@spmsUserReg" style="margin: 0;" class="textColour">Comparative Report</label>
        <div style="display: flex; margin-left: 40px;">
          
           
              <!-- <-- Upload File Section --> 
          <div style="display: flex;  align-items: center;">
            <form novalidate [formGroup]="FormValid" >

            <!-- Hidden file input -->
            <input
        type="file"
        id="imageupload"
        name="imageupload"
        (change)="chooseFile($event)"
        formControlName="imageupload"
        style="display: none;"
        #fileInput
      />
            <mat-error
        *ngIf="FormValid.get('imageupload')?.touched && FormValid.get('imageupload')?.invalid">
        Please select a Valid Excel file
      </mat-error>

            <!-- Upload File Button -->
            <button class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
              [style.background-color]="backgroundColorButton" title="Upload Report Input File to Compare"
              (click)="fileInput.click()" id="108">
              Upload File
              <em style="padding: 0px 0px 0px 10px; " class="fas fa-upload"
                title="Upload Report Input File to Compare"></em>
            </button>
            </form>
          </div>




          <div class="input-container" style="margin-top: 3.5vh;justify-items: center; padding: auto;"
            (click)="$event.stopPropagation()">
            <mat-form-field appearance="outline" style="width: 200px;align-items: center; ">
              <mat-label i18n="@@TMshoppingcomplexchooseimage">Enter Comparative Report Name</mat-label>

              <input matInput class="file-path validate" type="text" placeholder="Enter Report Name"
                [formControl]="FormValid.get('reportName')" [(ngModel)]="reportName" style="overflow: hidden;"
                (blur)="onReportNameBlur()" />
              <mat-error *ngIf="FormValid.get('reportName')?.touched && FormValid.get('reportName')?.invalid"
                style="font-size: 12px;  ">
                Report Name is required
              </mat-error>
            </mat-form-field>
          </div>



          <div style="display: flex; align-items: center; margin: 0; ">
            <!-- Generate Report Button -->
            <!-- button disabled until the Form is Vaildated -->
            <button class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
              [style.background-color]="backgroundColorButton" title="Generate" (click)="onGenerate()" id="114"
              [disabled]="!FormValid.valid">
              Generate Report
              <em title="Generate Report"></em>
            </button>
  
            <!-- Refresh Button -->
            <button style="width: 80px;"
              class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
              [style.background-color]="backgroundColorButton" title="Refresh" (click)="refreshData()">
              Refresh
              <em style="padding: 0px 0px 0px 0px" class="fas fa-sync-alt example-icon" title="Refresh"></em>
            </button>



            <button style="width: 80px;"
              class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
              [style.background-color]="backgroundColorButton" title="Download" (click)="onBtExport()">
              Download
              <em style="padding: 0px 0px 0px 0px" class="fas fa-download example-icon" title="Download"></em>
            </button>
          </div>

        </div>

        <!-- Page No -->
        <div class="insertPageNoDiv" style="width: 8%;">
          <mat-form-field appearance="outline">
            <mat-label i18n="@@Targetpageno">Page No</mat-label>
            <input matInput type="text" (input)="onSearchChange($event.target.value)" />
          </mat-form-field>
        </div>

        <div class="selectRecordsDiv" style="width: 8%">
          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label i18n="@@Targetrecords" style="color: black"
              >Records</mat-label
            >
            <mat-select
              [(ngModel)]="pageSize"
              (ngModelChange)="onPageSizeChanged(value)"
            >
              <mat-option value="10" selected>10</mat-option>
              <mat-option value="200">200</mat-option>
              <mat-option value="300">300</mat-option>
              <mat-option value="400">400</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <!-- pagination -->
         <div style="display: flex ;">
        <div
          class="card pagination paginationFirstButton paginationFirstlastButton"
        >
          <em
            class="fas fa-angle-double-left waves-effect waves-light"
            (click)="onBtFirst()"
          ></em>
        </div>
        <div class="card pagination paginationButtons btn-rounded">
          <ul>
            <li class="paginationliicon">
              <em
                class="fas fa-angle-left waves-effect waves-light"
                (click)="onBtPrevious()"
              ></em>
            </li>
            <li>{{ currentPage }}/{{ totalPages }}</li>
            <li class="paginationliicon" style="padding: 0">
              <em
                class="fas fa-angle-right waves-effect waves-light"
                (click)="onBtNext()"
              ></em>
            </li>
          </ul>
        </div>
        <div
          class="card pagination paginationLastButton paginationFirstlastButton"
        >
          <em
            class="fas fa-angle-double-right waves-effect waves-light"
            (click)="onBtLast()"
          ></em>
        </div>
      </div>
      </mat-toolbar>
    </div>

    <ag-grid-angular
      class="ag-theme-balham table-width tablestyles square scroolbar-dusty-grass square thin"
      [columnDefs]="columnDefs"
      [animateRows]="true"
      [pagination]="true"
  
      [defaultColDef]="defaultColDef"
      [suppressPaginationPanel]="true"
      [rowHeight]="35"
      [headerHeight]="35"
      [enableBrowserTooltips]="true"
      [floatingFiltersHeight]="45"
      [paginationPageSize]="paginationPageSize"
      [paginationNumberFormatter]="paginationNumberFormatter"
      [enableRangeSelection]="true"
      [components]="components"
      [debug]="true"
      [rowClassRules]="rowClassRules"
      (paginationChanged)="onPaginationChangedReturn()"
      (gridReady)="onGridReady($event)"
      [hidden]="!true"
    ></ag-grid-angular>
  </div>
</div>